<form
  [formGroup]="formGroup"
  [bitSubmit]="submit"
  bit-dialog
  [title]="'secretKeyAndPassword' | i18n"
  [subtitle]="data.email"
>
  <!-- disableClose hides the dialog's own close button. Like Cancel, this one waits out a sign-in. -->
  <button
    bitDialogHeaderEnd
    type="button"
    bitIconButton="bwi-close"
    buttonType="primaryGhost"
    size="default"
    [label]="'close' | i18n"
    id="onepassword-credentials-prompt_button_close"
    bitFormButton
    (click)="cancel()"
  ></button>

  <div bitDialogContent>
    <p bitTypography="body1">{{ "secretKeyAndPasswordDesc" | i18n }}</p>

    <bit-form-field>
      <bit-label>{{ "secretKey" | i18n }}</bit-label>
      <input
        bitInput
        type="password"
        id="onepassword-credentials-prompt_input_secret-key"
        formControlName="secretKey"
        appAutofocus
        appInputVerbatim
      />
      <button
        type="button"
        id="onepassword-credentials-prompt_button_toggle-secret-key"
        bitSuffix
        bitIconButton
        bitPasswordInputToggle
      ></button>
    </bit-form-field>

    <bit-form-field disableMargin>
      <bit-label>{{ "password" | i18n }}</bit-label>
      <input
        bitInput
        type="password"
        id="onepassword-credentials-prompt_input_password"
        formControlName="password"
        appInputVerbatim
      />
      <button
        type="button"
        id="onepassword-credentials-prompt_button_toggle-password"
        bitSuffix
        bitIconButton
        bitPasswordInputToggle
      ></button>
    </bit-form-field>
  </div>

  <ng-container bitDialogFooter>
    <button
      bitButton
      buttonType="primary"
      type="submit"
      id="onepassword-credentials-prompt_button_continue"
      bitFormButton
    >
      <span>{{ "continue" | i18n }}</span>
    </button>
    <button
      bitButton
      buttonType="secondary"
      type="button"
      id="onepassword-credentials-prompt_button_cancel"
      bitFormButton
      (click)="cancel()"
    >
      <span>{{ "cancel" | i18n }}</span>
    </button>
  </ng-container>
</form>
